export default "<fa-icon class=\"alpha-pageheader-icon\" [icon]=\"geticon()\"></fa-icon>\r\n"